import styled from 'styled-components'
import { Button } from '../components'

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  width: 100%;
`

export const SegmentGroup = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-shrink: 0;
`

export const SegmentButton = styled(Button)`
  margin: 0;
  border-right-width: 0;
  border-radius: 0;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  white-space: nowrap;

  &:first-child {
    border-radius: 25px 0 0 25px;
  }

  &:last-child {
    border-radius: 0 25px 25px 0;
    border-right-width: 1px;
  }

  &:hover {
    ${({ active, theme }) => active && `background-color: ${theme.button.activeBackgroundColor};`}
    ${({ active, theme }) => active && `color: ${theme.button.activeTextColor};`}
  }
`

export const OptionLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
`

/** High-contrast novelty badge — stays readable on active and inactive segment states. */
export const NewBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.06rem;
  line-height: 1.2;
  text-transform: uppercase;
  background: ${({ theme }) => theme.colors.red};
  color: #fff;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.35);
`
